// BackButton.js
import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import "./BackButton.css";

const BackButton = ({ onClick }) => {
  return (
    <button
      type="button"
      className="eduok-back-btn"
      aria-label="Back"
      onClick={onClick || (() => window.history.back())}
    >
      <span className="eduok-back-btn__icon" aria-hidden>
        <FaArrowLeft />
      </span>
      <span className="eduok-back-btn__label">Back</span>
    </button>
  );
};

export default BackButton;
